// Analytics tab. There is one workspace, so this is a pass-through to the
// invoice dashboard: the workspace button row it used to carry was a one-option
// control and is deleted (docs/app.md §2 — "no dead toggles"). The tab stays
// its own file so a second workspace later has somewhere to branch.
import type { Session } from '../lib/identity'
import { DashboardScreen } from './DashboardScreen'

interface Props {
  session: Session
  refreshNonce?: number
}

export function AnalyticsScreen({ session, refreshNonce }: Props) {
  return <DashboardScreen session={session} refreshNonce={refreshNonce} />
}
